var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { ContainerElementType } from './Container.enum';
import handleContainerPadding from './Container.helpers';
const BaseContainer = styled.div `
  display: grid;
  width: 100%;
  max-width: 1270px;
  margin-left: auto;
  margin-right: auto;
  background: ${({ background }) => background || 'none'};
  ${({ margin }) => margin && `margin: ${margin};`}
  ${({ before, }) => before && `&::before { ${css `${before}`} }`}
  ${({ after, }) => after && `&::after { ${css `${after}`} }`}
    ${({ noPadding }) => handleContainerPadding(noPadding)}
    ${({ customCss }) => customCss || ''}
`;
const Container = forwardRef((_a, ref) => {
    var { as, background, children } = _a, delegated = __rest(_a, ["as", "background", "children"]);
    return (_jsx(BaseContainer, Object.assign({ ref: ref }, delegated, { as: as || ContainerElementType.DIV, background: background }, { children: children }), void 0));
});
export default Container;
//# sourceMappingURL=Container.js.map